// extracted by mini-css-extract-plugin
export default {"container":"InputWithPrefix_container__9FXpC","label":"InputWithPrefix_label__OvwNo","prefix":"InputWithPrefix_prefix__OaY4i"};